import { logEvent } from '@amplitude/analytics-browser';
import { Capacitor } from '@capacitor/core';
import { configureCache, GrowthBook } from '@growthbook/growthbook-react';
import {
  GROWTHBOOK_CLIENT_KEYS,
  UPSTASH_REDIS_REST_TOKEN,
  UPSTASH_REDIS_REST_URL,
} from 'src/config';
import { FEATURE_FLAGS_TYPE } from 'src/utils/growthBook/growthBook.constants';
import { RedisStickyBucketService } from 'src/utils/growthBook/RedisStickyButingService';

const platform = Capacitor.getPlatform() as 'ios' | 'android' | 'web';

configureCache({
  disableCache: true,
});

const growthbook = new GrowthBook<FEATURE_FLAGS_TYPE>({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: GROWTHBOOK_CLIENT_KEYS[platform],
  stickyBucketService: new RedisStickyBucketService({
    redisToken: UPSTASH_REDIS_REST_TOKEN,
    redisUrl: UPSTASH_REDIS_REST_URL,
  }),
  subscribeToChanges: true,
  trackingCallback: (experiment, result) => {
    logEvent('experimentViewed', {
      name: experiment.name,
      experimentId: experiment.key,
      key: result.key,
      bucketUsed: result.stickyBucketUsed,
      hashAttribute: result.hashAttribute,
      variationId: result.variationId,
      hash: result.hashValue,
      value: result.value,
    });
  },
});

growthbook.init({ streaming: true });

export default growthbook;
